import styled from 'styled-components';
import { ImageUtils } from '../../../utils/ImageUtils';
import { BottomSns } from '../../common/BottomSnsImg';
import { mobileQuery } from '../../../utils';

export const RewardInfo = () => {
  return (
    <>
      <Wrap>
        <TextContainer>
          <TotalRewardText>230,000,000 GTD</TotalRewardText>
        </TextContainer>

        <LabelRed>
          <LabelText>온라인 새틀라이트</LabelText>
        </LabelRed>

        <EventRow>
          <EventInfoLeft>
            <EventTitleRed>700만 Step to 7000만</EventTitleRed>
          </EventInfoLeft>
          <EventInfoRight>
            <EventDate>
              2월 12일(목) ~ 3월 20일(금)
              <br />
              <span>매일 오후 12시, 1시, 2시</span>
            </EventDate>
            <EventVenueContainer>
              <img src={ImageUtils.AppIcon} alt="" />
              <EventVenue>피망 쇼다운 홀덤 앱</EventVenue>
            </EventVenueContainer>
          </EventInfoRight>
        </EventRow>

        <EventRow>
          <EventInfoLeft>
            <EventTitleRed>7000만 Step to 7억</EventTitleRed>
          </EventInfoLeft>
          <EventInfoRight>
            <EventDate>
              2월 12일(목) ~ 3월 20일(금)
              <br />
              <span>매일 오후 4시, 5시, 6시</span>
            </EventDate>
            <EventVenueContainer>
              <img src={ImageUtils.AppIcon} alt="" />
              <EventVenue>피망 쇼다운 홀덤 앱</EventVenue>
            </EventVenueContainer>
          </EventInfoRight>
        </EventRow>

        <EventRow>
          <EventInfoLeft>
            <EventTitleRed>새틀라이트</EventTitleRed>
          </EventInfoLeft>
          <EventInfoRight>
            <EventDate>
              2월 12일(목) ~ 3월 20일(금)
              <br />
              <span>매일 오후 7시, 9시, 11시</span>
            </EventDate>
            <EventVenueContainer>
              <img src={ImageUtils.AppIcon} alt="" />
              <EventVenue>피망 쇼다운 홀덤 앱</EventVenue>
            </EventVenueContainer>
          </EventInfoRight>
        </EventRow>

        <LabelBlue>
          <LabelText>오프라인 이벤트</LabelText>
        </LabelBlue>

        <EventRow>
          <EventInfoLeft>
            <EventTitleBlue>메인 이벤트</EventTitleBlue>
            <EventVenue>마리나 썬셋 101</EventVenue>
          </EventInfoLeft>
          <EventInfoRight>
            <EventDays>
              <EventLocation>
                <span>DAY1</span>
                <p>3월 21일(토) 오후 12시</p>
              </EventLocation>
              <EventLocation>
                <span>DAY2</span>
                <p>3월 22일(일) 오전 11시</p>
              </EventLocation>
            </EventDays>
          </EventInfoRight>
        </EventRow>

        <EventRow>
          <EventInfoLeft>
            <EventTitleBlue>사이드 이벤트</EventTitleBlue>
            <EventVenue>마리나 썬셋 101</EventVenue>
          </EventInfoLeft>
          <EventInfoRight>
            <EventDays>
              <EventLocation>
                <span>DAY1</span>
                <p>3월 22일(일) 오후 12시</p>
              </EventLocation>
            </EventDays>
          </EventInfoRight>
        </EventRow>

        <PartnerSection>
          <PartnerRow>
            <TitleContainer>
              <PartnerTitle>주최</PartnerTitle>
            </TitleContainer>
            <PartnerLogo>
              <PartnerIcon1 src={ImageUtils.PartnerIcon1} alt="KPS" />
            </PartnerLogo>
          </PartnerRow>

          <PartnerRow>
            <TitleContainer>
              <PartnerTitle>주관대행</PartnerTitle>
            </TitleContainer>
            <PartnerLogo>
              <PartnerIcon2 src={ImageUtils.PartnerIcon2} alt="KPS" />
            </PartnerLogo>
          </PartnerRow>

          <PartnerRow>
            <TitleContainer>
              <PartnerTitle>장소</PartnerTitle>
            </TitleContainer>
            <PartnerLogo>
              <PartnerIcon3 src={ImageUtils.PartnerIcon3} alt="KPS" />
            </PartnerLogo>
          </PartnerRow>

          <PartnerRow>
            <TitleContainer>
              <PartnerTitle>후원</PartnerTitle>
            </TitleContainer>
            <PartnerLogo>
              <PartnerIcon4 src={ImageUtils.PartnerIcon4} alt="KPS" />
            </PartnerLogo>
          </PartnerRow>
        </PartnerSection>
      </Wrap>
      <BottomSns />
    </>
  );
};

const EventLocation = styled.div<{ hasSpace?: boolean }>`
  display: flex;
  margin-bottom: ${(props) => (props.hasSpace ? '10px' : '0px')};
  width: 100%;
  justify-content: space-between;

  span {
    margin-bottom: 0;
  }

  ${mobileQuery} {
  }
`;

const TextContainer = styled.div`
  background: linear-gradient(249deg, #ffe993 18.33%, #ffbe46 78.59%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 17px;
  margin-top: 32px;

  ${mobileQuery} {
    margin-top: 0;
    margin-bottom: 0px;
  }
`;

const TotalRewardText = styled.h2`
  font-size: 75px;
  font-weight: 800;
  line-height: 102px;

  ${mobileQuery} {
    font-size: 44px;
    line-height: 82px;
  }
`;

const Wrap = styled.div`
  text-align: center;
  padding-bottom: 150px;
  max-width: 820px;
  margin: 0 auto;

  ${mobileQuery} {
    padding-top: 0px;
    padding-right: 10px;
    padding-left: 10px;
  }
`;

const Label = styled.div`
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mobileQuery} {
    height: 26px;
  }
`;

const LabelRed = styled(Label)`
  border-top: 2px solid #d92a76;
  border-bottom: 1px solid #d92a76;
  background: linear-gradient(90deg, rgba(201, 0, 80, 0.7) 25.71%, rgba(164, 0, 71, 0.7) 86.89%);
`;

const LabelBlue = styled(Label)`
  border-top: 2px solid #1e95f6;
  border-bottom: 1px solid #1e95f6;
  background: linear-gradient(91deg, rgba(0, 155, 251, 0.8) 10.71%, rgba(0, 114, 207, 0.8) 84.3%);
  margin-top: 12px;
  ${mobileQuery} {
    margin-top: 8px;
  }
`;

const LabelText = styled.p`
  font-weight: 500;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;

  ${mobileQuery} {
    font-size: 15px;
    line-height: 21px;
  }
`;

const EventRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  text-align: left;
  margin-bottom: 2px;
  background-color: #222;
  width: 100%;
  &:last-child {
    margin-bottom: 0;
  }

  ${mobileQuery} {
    padding: 0px 10px;
    padding-top: 5px;
    padding-bottom: 6px;
  }
`;

const EventInfoLeft = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;

const EventInfoRight = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const EventTitleRed = styled.h3`
  font-size: 20px;
  font-weight: 400;
  color: #ff63a2;
  font-weight: 700;

  ${mobileQuery} {
    font-size: 16px;
  }
`;

const EventTitleBlue = styled.h3`
  font-size: 22px;
  font-weight: 700;
  color: #47acff;

  ${mobileQuery} {
    font-size: 16px;
  }
`;

const EventDate = styled.p`
  font-size: 20px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  span {
    color: rgba(255, 255, 255, 0.5);
  }

  ${mobileQuery} {
    font-size: 16px;
  }
`;

const EventDays = styled.div`
  width: 100%;
  font-size: 22px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;

  span {
    color: white;
    font-size: 22px;
    font-weight: 700;
  }
  ${mobileQuery} {
    font-size: 15px;

    span {
      font-size: 15px;
    }
  }
`;

const EventVenueContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  img {
    display: none;
  }

  ${mobileQuery} {
    img {
      display: block;
      width: 34px;
      margin-bottom: 2px;
    }
  }
`;

const EventVenue = styled.p`
  font-size: 20px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;

  ${mobileQuery} {
    font-size: 13px;
  }
`;

const PartnerSection = styled.div`
  margin-top: 20px;
  display: flex;

  ${mobileQuery} {
    flex-wrap: wrap;
    margin-top: 8px;

    > div:nth-child(even) {
      border-right: none;
    }

    > div:nth-child(3) {
      border-bottom: 1px solid #000000;
    }

    > div:nth-child(4) {
      border-bottom: 1px solid #000000;
    }
  }
`;

const PartnerRow = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-right: 1px solid rgba(255, 255, 255, 0.1);

  &:last-child {
    border-right: none;
  }

  ${mobileQuery} {
    flex-basis: 50%;
    border-right: 1px solid #000000;
  }
`;

const TitleContainer = styled.div`
  background: rgba(0, 0, 0, 0.1);
  height: 48px;
  border-bottom: 1px solid #000000;

  display: flex;
  align-items: center;
  justify-content: center;

  ${mobileQuery} {
    height: 24px;
  }
`;

const PartnerTitle = styled.h3`
  font-weight: 500;
  font-size: 20px;
  letter-spacing: -0.04em;
  color: rgba(255, 255, 255, 0.8);
  font-family: 'Gmarket Sans TTF';

  &:last-child {
    margin-right: 0;
  }

  ${mobileQuery} {
    font-size: 12px;
    line-height: 24px;
  }
`;

const PartnerLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
  height: 110px;
  background: rgba(0, 0, 0, 0.2);

  p {
    color: rgba(255, 255, 255, 0.8);
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.6px;
  }
  img {
    max-width: 80%;
    max-height: 80px;
    margin: 0 5px;
  }

  ${mobileQuery} {
    p {
      font-size: 15px;
    }

    height: 55px;
  }
`;

const PartnerIcon1 = styled.img`
  ${mobileQuery} {
    width: 104px;
  }
`;
const PartnerIcon2 = styled.img`
  ${mobileQuery} {
    width: 64px;
  }
`;
const PartnerIcon3 = styled.img`
  ${mobileQuery} {
    width: 90px;
  }
`;
const PartnerIcon4 = styled.img`
  ${mobileQuery} {
    width: 68px;
  }
`;
